<template>
  <el-table-column
    prop="target_user_name"
    sortable="custom"
    label="Átvevő"
    show-overflow-tooltip
    min-width="150"
  />
</template>

<script>
  export default {
    propName: 'target_user_name',
  };
</script>
